// extracted by mini-css-extract-plugin
export default {"card":"RelatedSiteCard_card__7LRXs","topic":"RelatedSiteCard_topic__ct0Rt","description":"RelatedSiteCard_description__xNmZZ","deliveryTypes":"RelatedSiteCard_deliveryTypes__TWrqx"};